import React from 'react';

/** Isolated visual reference. Does NOT send any data to the production backend. */
export default function PrototypePreview() {
  return (
    <div style={{height:'100vh',display:'flex',flexDirection:'column',background:'#f8fafc'}}>
      <div style={{padding:'10px 16px',fontFamily:'Arial,sans-serif',fontSize:13,
        background:'#fff4db',color:'#5f4200',borderBottom:'1px solid #dfc990'}}>
        <strong>DESIGN PREVIEW ONLY</strong> — fictional records and browser-local demo actions.
        Not connected to Beauty Spot's API, database, Stripe or live accounts.
      </div>
      <iframe title="Beauty Spot recovered admin prototype" src="/prototype-preview/index.html"
        sandbox="allow-scripts allow-same-origin allow-forms allow-modals allow-downloads"
        style={{border:0,flex:1,width:'100%'}} />
    </div>
  );
}
